export const timeOptions = [
  {
    title: '08:00',
    _id: '08:00',
  },
  {
    title: '08:30',
    _id: '08:30',
  },
  {
    title: '09:00',
    _id: '09:00',
  },
  {
    title: '09:30',
    _id: '09:30',
  },
  {
    title: '10:00',
    _id: '10:00',
  },
  {
    title: '10:30',
    _id: '10:30',
  },
  {
    title: '11:00',
    _id: '11:00',
  },
  {
    title: '11:30',
    _id: '11:30',
  },
  {
    title: '12:00',
    _id: '12:00',
  },
  {
    title: '12:30',
    _id: '12:30',
  },
  {
    title: '13:00',
    _id: '13:00',
  },
  {
    title: '13:30',
    _id: '13:30',
  },
  {
    title: '14:00',
    _id: '14:00',
  },
  {
    title: '14:30',
    _id: '14:30',
  },
  {
    title: '15:00',
    _id: '15:00',
  },
  {
    title: '15:30',
    _id: '15:30',
  },
  {
    title: '16:00',
    _id: '16:00',
  },
  {
    title: '16:30',
    _id: '16:30',
  },
  {
    title: '17:00',
    _id: '17:00',
  },
  {
    title: '17:30',
    _id: '17:30',
  },
  {
    title: '18:00',
    _id: '18:00',
  },
  {
    title: '18:30',
    _id: '18:30',
  },
  {
    title: '19:00',
    _id: '19:00',
  },
  {
    title: '19:30',
    _id: '19:30',
  },
  {
    title: '20:00',
    _id: '20:00',
  },
];
